import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Col, Modal, Row } from "react-bootstrap";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import {
  sportslist,
  typeparametercreate,
  typeparameterdelete,
  typeparameterdetail,
  typeparameterlist,
  typeparameterupdate,
} from "../../../../services/master";
import Select from "react-select";

export const ParameterTypeMaster = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [show, setShow] = useState(false);
  const [paraid, setId] = useState(0);
  const [paraname, setParameter] = useState("");
  const [paradesc, setParaDesc] = useState("");

  const [sportid, setSport] = useState("");
  const [slist, setSList] = useState([]);
  const [status, setStatus] = useState("1");
  const [errorMsg, setErrorMsg] = useState("");

  const sorting = useMemo(() => {
    return ["asc", "desc"];
  }, []);

  const columnDefs = [
    {
      headerName: "Parameter Type",
      field: "parameter_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Sports",
      field: "sports_category",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "status",
      resizable: true,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onChange={() => deletedistrict(params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Actions",
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => vireparameter(params.value)}
              title="Edit Parameter Type"
              className="btn-sm btn-secondary"
            >
              <i className="fa fa-edit fa-lg"></i>
            </a>
          </div>
        );
      },
    },
  ];

  function vireparameter(aid) {
    setShow(true);
    typeparameterdetail(aid).then((response) => {
      if (response.status === true) {
        setId(response.data.sportsParameters.id);

        sportslist().then((res) => {
          if (res.status === true) {
            if (res.data.length !== 0) {
              let arr = [];
              for (let i = 0; i < res.data.length; i++) {
                if (
                  response.data.sportsParameters.sports_id ==
                  res.data[i].sports_cat_uid
                ) {
                  arr.push({
                    label: res.data[i].sports_category,
                    value: res.data[i].sports_cat_uid,
                  });
                }
              }
              setSport(arr[0]);
            }
          }
        });
        setParameter(response.data.sportsParameters.parameter_type);
        setParaDesc(response.data.sportsParameters.description);

        setStatus(response.data.sportsParameters.status + "");
        dotracking(
          "edit button in parameter type for " +
            response.data.parameter_type +
            " (" +
            aid +
            ") $$ " +
            trackobj.parametertypeheading
        );
      }
    });
  }

  function handleshow() {
    setId(0);
    setParameter("");
    setParaDesc("");
    setSport("");
    setStatus("1");
    setErrorMsg("");
    setShow(true);
  }
  function handleclose() {
    setShow(false);
    setId(0);
    setParameter("");
    setParaDesc("");
    setSport("");
    setStatus("1");
    setErrorMsg("");
  }

  function deletedistrict(list) {
    if (list.value === 1) {
      Swal.fire({
        text: "Are you sure want to Inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Inactive",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("parameter_id", list.data.id);
          temp.append("active_inactive", 0);
          dotracking(
            "status icon in parameter type list from Inactive to Active for " +
              list.data.parameter_type +
              " (" +
              list.data.id +
              ") $$ " +
              trackobj.parametertypeheading
          );
          typeparameterdelete(temp).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Active?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Active",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("parameter_id", list.data.id);
          temp.append("active_inactive", 1);
          dotracking(
            "status icon in parameter type list from Inactive to Active for " +
              list.data.parameter_type +
              " (" +
              list.data.id +
              ") $$ " +
              trackobj.parametertypeheading
          );
          typeparameterdelete(temp).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    }
  }
  useEffect(() => {
    listall();
    sportslist().then((response) => {
      if (response.status === true) {
        if (response.data.length !== 0) {
          let arr = [];
          for (let i = 0; i < response.data.length; i++) {
            arr.push({
              label: response.data[i].sports_category,
              value: response.data[i].sports_cat_uid,
            });
          }
          setSList(arr);
        }
      }
    });
  }, []);

  function listall() {
    setFilterProduct([]);
    typeparameterlist().then((response) => {
      if (response.status === true) {
        setFilterProduct(response.data.sportsParameters);
      }
    });
  }

  //   function Selectstatus(e) {
  //     setStatus(e.target.value);
  //   }

  function submitdistrict(e) {
    e.preventDefault();
    setErrorMsg("");
    if (paraname !== "") {
      if (sportid !== "") {
        if (paraid === 0) {
          const temp = new FormData();
          temp.append("sports_id", sportid.value);
          temp.append("parameter_type", paraname);
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("description", paradesc);

          dotracking(
            "add button for parameter in parameter type list for " +
              paraname +
              " (" +
              paraid +
              ") $$ " +
              trackobj.parametertypeheading
          );
          typeparametercreate(temp).then((response) => {
            if (response.status === true) {
              handleclose();
              listall();
              toast.success(response.message);
            }
          });
        } else if (paraid !== 0) {
          const temp = new FormData();
          temp.append("parameter_id", paraid);
          temp.append("sports_id", sportid);
          temp.append("parameter_type", paraname);
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("description", paradesc);

          // temp.append("isactive", status)
          dotracking(
            "update button for parameter in parameter type list for " +
              paraname +
              " (" +
              paraid +
              ") $$ " +
              trackobj.parametertypeheading
          );
          typeparameterupdate(temp).then((response) => {
            if (response.status === true) {
              handleclose();
              listall();
              toast.success(response.message);
            }
          });
        }
      } else {
        setErrorMsg("Please Select Sports");
      }
    } else {
      setErrorMsg("Please Enter Parameter Type");
    }
  }

  function handleSport(e) {
    if (e !== null) {
      setSport(e);
    } else {
      setSport("");
    }
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Parameter Type Lists</h4>
        </div>
        <ol className="breadcrumb">
          {localStorage.getItem("Subrole") === "1" && (
            <li className="breadcrumb-item">
              <a>Setup</a>
            </li>
          )}
          {localStorage.getItem("Subrole") !== "1" && (
            <li className="breadcrumb-item">
              <a>Master</a>
            </li>
          )}
          <li className="breadcrumb-item active" aria-current="page">
            Parameter Type Lists
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <div className="text-right">
                <a className="btn btn-success" onClick={handleshow}>
                  <i className="fa fa-plus"></i> Add Parameter Type
                </a>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={sorting}
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                  domLayout="autoWidth"
                  onGridReady={(params) => {
                    params.api.sizeColumnsToFit();
                  }}
                />
              </div>

              <Modal show={show} size="lg" onHide={handleclose}>
                <Modal.Header>
                  {paraid !== 0 && <h4> Parameter Type Details</h4>}
                  {paraid === 0 && <h4> Add Parameter Type</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                  {paraid === 0 && (
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <label className="mb-2">
                            Sports <span className="errortext"> *</span>
                          </label>
                          <Select
                            className="dropdown"
                            placeholder="Select Sports"
                            value={sportid}
                            options={slist}
                            onChange={handleSport}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </Col>
                    )}
                    {paraid !== 0 && (
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <label className="mb-2">
                            Sports <span className="errortext"> *</span>
                          </label>
                          <Select
                            className="dropdown"
                            placeholder="Select Sports"
                            value={sportid}
                            options={slist}
                            onChange={handleSport}
                            isSearchable={true}
                            isClearable
                            hidden
                            isDisabled
                          />
                        </div>
                      </Col>
                    )}

                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Parameter Type <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Parameter Type"
                          className="form-control"
                          value={paraname}
                          onChange={(e) => setParameter(e.target.value)}
                        />
                      </div>
                    </Col>

                   <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Description
                           {/* <span className="errortext"> *</span> */}
                        </label>
                        <textarea
                          rows={3}
                          placeholder="Description"
                          className="form-control"
                          value={paradesc}
                          onChange={(e) => setParaDesc(e.target.value)}
                        />
                      </div>
                    </Col>
                    {/* <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Status <span className="errortext"> *</span>
                                                </label>

                                                <div className="row" onChange={Selectstatus}>
                                                    <div className="col-md-6">
                                                        <label className="custom-control custom-radio custom-control-md">
                                                            <input
                                                                type="radio"
                                                                className="reg-chk"
                                                                id="active"
                                                                value="1"
                                                                checked={status === "1"}
                                                            />
                                                            {" "} Active
                                                        </label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="custom-control custom-radio custom-control-md">
                                                            <input
                                                                type="radio"
                                                                className="reg-chk"
                                                                id="active"
                                                                value="0"
                                                                checked={status === "0"}
                                                            />
                                                            {" "}Inactive
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Col> */}
                    {errorMsg !== "" && (
                      <span className="errortext">{errorMsg}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={handleclose}>
                    Close
                  </a>
                  {paraid !== 0 && (
                    <a className="btn btn-success" onClick={submitdistrict}>
                      Update
                    </a>
                  )}
                  {paraid === 0 && (
                    <a className="btn btn-success" onClick={submitdistrict}>
                      Add
                    </a>
                  )}
                </Modal.Footer>
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
